export const showPreviousTab = (tabGroup) => {
  const tabList = tabGroup.querySelector('.nav-tabs');
  const currentTab = tabList.querySelector('.nav-link.active');
  const previousTab = currentTab.previousElementSibling;
  const lastTab = tabList.querySelector('.nav-link:last-child');

  return previousTab === null ? lastTab.click() : previousTab.click();
};

export const showNextTab = (tabGroup) => {
  const tabList = tabGroup.querySelector('.nav-tabs');
  const currentTab = tabList.querySelector('.nav-link.active');
  const nextTab = currentTab.nextElementSibling;
  const firstTab = tabList.querySelector('.nav-link:first-child');

  return nextTab === null ? firstTab.click() : nextTab.click();
};

export function initializeTabGroup() {
  /* eslint-disable*/
  let gridTab = document.querySelector('.grid-tab');
  if (gridTab) {
    let desktopSize = parseInt(gridTab.dataset.desktopSize);
    let mobileSize = parseInt(gridTab.dataset.mobileSize);
    let currentSize = window.innerWidth >= 576 ? desktopSize : mobileSize;
    gridTab.querySelectorAll('.tab-pane').forEach((el) => {
      let cards = el.querySelectorAll('.grid-card');
      cards.forEach((el, i) => {
        if (i < currentSize) {
          el.classList.remove('card-not-displayed');
        }
      });
      let showMore =
        cards.length - currentSize > currentSize
          ? currentSize
          : cards.length - currentSize;
      el.querySelectorAll('.show-more-wrapper').forEach((el) => {
        if (showMore <= 0) {
          el.classList.add('card-not-displayed');
        } else {
          let btn = el.querySelector('button');
          btn.innerText = `Show ${showMore} more`;
          let btnLabelDiv = el.querySelector('.show-more-text');
          btnLabelDiv.innerText = `Showing events 1-${currentSize} of ${cards.length}`;
          btn.addEventListener('click', () =>
            showMoreCards(cards, currentSize, btn, btnLabelDiv)
          );
        }
      });
    });
  }
  /* eslint-enable */
  const tabGroups = document.querySelectorAll('.tab-group');
  tabGroups.forEach((tabGroup) => {
    const nextBtn = tabGroup.querySelector('.btn-next-tab');
    const prevBtn = tabGroup.querySelector('.btn-prev-tab');

    if (nextBtn) {
      nextBtn.addEventListener('click', () => showNextTab(tabGroup));
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', () => showPreviousTab(tabGroup));
    }
  });
}

export function showMoreCards(cards, currentSize, btn, btnLabelDiv) {
  /* eslint-disable*/
  let hiddenCards = [...cards].filter((el) =>
    el.classList.contains('card-not-displayed')
  );
  let startCount = cards.length - hiddenCards.length;
  hiddenCards.forEach((el, i) => {
    if (i < currentSize) {
      el.classList.remove('card-not-displayed');
    }
  });
  let showMore =
    hiddenCards.length - currentSize > currentSize
      ? currentSize
      : hiddenCards.length - currentSize;
  if (showMore <= 0) {
    btn.parentElement.classList.add('card-not-displayed');
  } else {
    btn.innerText = `Show ${showMore} more`;
    btnLabelDiv.innerText = `Showing events 1-${currentSize + startCount} of ${
      cards.length
    }`;
  }
  /* eslint-enable */
}
